import { useGameStore } from '@hollowveil/shared';
import './WorldIndicator.css';

export function WorldIndicator() {
  const { currentWorld, currentRoom } = useGameStore();

  if (!currentRoom?.hasSpectralLayer) {
    return null;
  }

  return (
    <div className={`world-indicator ${currentWorld}`}>
      <span className="world-name">
        {currentWorld === 'real' ? 'Realm of Light' : 'The Veil'}
      </span>
      {currentRoom?.name && (
        <span className="level-name">{currentRoom.name}</span>
      )}
    </div>
  );
}
